// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1imIm","balanceDisclaimer":"posDashboard_balanceDisclaimer__3aW8K"};